import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, Home, ArrowLeft } from "lucide-react";
import { Link, useLocation } from "wouter";

export default function NotFound() {
  const [location] = useLocation();

  return (
    <div className="h-full w-full flex items-center justify-center py-12">
      <Card className="w-full max-w-md mx-4 shadow-lg border-none">
        <CardHeader className="pb-2">
          <div className="flex items-center gap-2 mb-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <CardTitle className="text-2xl font-bold">Page Not Found</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">
            The page you're looking for doesn't exist or might have been moved.
          </p>
          <div className="p-4 bg-gray-50 rounded-md border border-gray-100 mb-6">
            <p className="text-sm font-mono text-gray-500 break-all">{location}</p>
          </div>
        </CardContent>
        <CardFooter className="flex gap-3 justify-between">
          <Button variant="outline" size="sm" onClick={() => window.history.back()}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
          <Button size="sm" asChild>
            <Link href="/">
              <Home className="h-4 w-4 mr-2" />
              Dashboard
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
